<template>
    <form id="editResponsiblesForm">
        <modal-component id="editResponsibles" modal-type="modal-lg">
            <template v-slot:title>Editar Clientes Responsáveis</template>

            <template v-slot:default>
                <div class="row">
                    <div class="col-9">
                        <multiselect-component
                            data-type="responsibleList"
                            title="Responsáveis para envio do email de chamado"
                            name="occurrence_responsible"
                            height="height: 80px"
                            id="responsible_edit"
                            ref="responsible"
                            :required="true"
                            :disabled="false"
                            :readonly="false"
                        ></multiselect-component>
                    </div>
                    <div class="col-3">
                        <button
                            type="button"
                            class="btn btn-danger btn-block mt-5"
                            id="occurrence_delete_responsible"
                            v-on:click="deleteResponsible()"
                        >
                            <i class="fas fa-window-close fa-fw"></i> Deletar
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <input-component
                            id="new_responsible"
                            ref="new_responsible"
                            name="new_responsible"
                            type="text"
                            title="Responsável"
                            icon="fas fa-user fa-fw"
                            placeholder="Responsável"
                            :required="true"
                            :readonly="false"
                        ></input-component>
                    </div>
                    <div class="col-4">
                        <input-component
                            id="new_phone1"
                            ref="new_phone1"
                            name="new_phone1"
                            icon="fas fa-phone fa-fw"
                            title="Telefone 1"
                            placeholder="Telefone 1"
							:mask="['(##) ####-####', '(##) #####-####']"
                            :required="true"
                            :readonly="false"
                        ></input-component>
                    </div>
                    <div class="col-4">
                        <input-component
                            id="new_phone2"
                            ref="new_phone2"
                            name="new_phone2"
                            icon="fas fa-phone fa-fw"
                            title="Telefone 2"
                            placeholder="Telefone 2"
							:mask="['(##) ####-####', '(##) #####-####']"
                            :required="false"
                            :readonly="false"
                        ></input-component>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <input-component
                            id="new_email"
                            ref="new_email"
                            name="new_email"
                            icon="fas fa-envelope-square fa-fw"
                            title="Email"
                            placeholder="Email"
                            :required="true"
                            :readonly="false"
                        ></input-component>
                    </div>
                    <div class="col-3">
                        <button
                            type="button"
                            class="btn btn-success btn-block"
                            style="margin-top:30px"
                            id="occurrence_add_responsible"
                            v-on:click="addResponsible()"
                        >
                            <i class="fas fa-plus fa-fw"></i> Adicionar
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:footer>
                <button
                    data-dismiss="modal"
                    type="button"
                    class="btn btn-success"
                    id="occurrence_save_responsibles"
                    :disabled="responsiblesData == '' ? true : false"
                    v-on:click="saveResponsibles()"
                >
                    <i class="fas fa-check"></i> Ok
                </button>
                <button data-dismiss="modal" type="button" class="btn btn-secondary">
                    <i class="fas fa-window-close fa-fw"></i>
                    Fechar
                </button>
            </template>
        </modal-component>
    </form>
</template>

<script>
export default {
    data() {
        return {
            url: window.location.pathname,
            responsiblesData: []
        };
    },
    mounted() {
        const self = this;
        this.$root.$on("responsibles-data", function(data) {
            self.responsiblesData = data;
            self.$refs.responsible.listData = data;
        });

        $("#editResponsibles").on("hidden.bs.modal", function(event) {
            self.$refs.responsible.listData = "";
            this.responsiblesData = [];
        });
    },

    methods: {
        addResponsible() {
            if (this.checkResponsible()) {
                let responsible = this.$refs.new_responsible.actualVal;
                let phone1 = this.$refs.new_phone1.actualVal;
                let phone2 = this.$refs.new_phone2.actualVal;
                let email = this.$refs.new_email.actualVal;
                this.responsiblesData.push({
                    id: responsible,
                    name: `${responsible}/${phone1}/${phone2}/${email}`
                });
                this.$refs.responsible.listData = this.responsiblesData;
                this.$refs.new_responsible.actualVal = "";
                this.$refs.new_phone1.actualVal = "";
                this.$refs.new_phone2.actualVal = "";
                this.$refs.new_email.actualVal = "";
            }
        },

        deleteResponsible() {
            let deleteResponsibles = this.$refs.responsible.actualVal;
            let responsibles = this.responsiblesData;
            let newReponsibles = [];

            if (deleteResponsibles != "") {
                for (var i = 0; i < responsibles.length; i++) {
                    if (deleteResponsibles.indexOf(responsibles[i].id) <= -1) {
                        newReponsibles.push(responsibles[i]);
                    }
                }

                this.responsiblesData = newReponsibles;
                this.$refs.responsible.listData = this.responsiblesData;
            } else {
                Swal.fire({
                    html:
                        "Por favor, selecione uma ou mais linhas no campo de responsáveis para deletar.",
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
            }
        },

        checkResponsible() {
            if (this.$refs.new_responsible.actualVal == "") {
                Swal.fire({
                    html: 'O campo "Responsável" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }
            if (
                this.$refs.new_phone1.actualVal == ""
            ) {
                Swal.fire({
                    html: 'O campo de "Telefone 1" não foram preenchidos!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }
            if (this.$refs.new_email.actualVal == "") {
                Swal.fire({
                    html: 'O campo "email" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }

            return true;
        },

        saveResponsibles() {
            this.$root.$emit("responsibles-data", this.responsiblesData);
        }
    }
};
</script>

